var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "faq" } },
    [
      _c("h2", [_vm._v(_vm._s(_vm.$t("message.faq.title")))]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("VueFaqAccordion", {
        attrs: {
          items: _vm.myItems,
          "font-color": "#404b69",
          "border-color": "#404b69"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-839193d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-839193d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Faq.vue
// module id = null
// module chunks = 